export enum AccountOriginEnum {
  KBC = "KBC",
}
export enum AuthorizationResponseSlugEnum {
  CARD_ACTIVATION = "CARD_ACTIVATION",
  CARD_LAYOUT_VIEW = "CARD_LAYOUT_VIEW",
  CARD_PIN_VIEW = "CARD_PIN_VIEW",
  DEBT_REPAYMENT_PLAN = "DEBT_REPAYMENT_PLAN",
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  EMAIL_CHANGE = "EMAIL_CHANGE",
  LOGIN = "LOGIN",
  INSTALLMENTS_CONTRACT = "INSTALLMENTS_CONTRACT",
  INVESTMENTS_SETTINGS = "INVESTMENTS_SETTINGS",
  PAY_IN_THREE = "PAY_IN_THREE",
  PAYMENT_ORDER = "PAYMENT_ORDER",
  PAYMENT_ORDER_TEMPLATE_CREATE = "PAYMENT_ORDER_TEMPLATE_CREATE",
  PAYMENT_ORDER_TEMPLATE_DELETE = "PAYMENT_ORDER_TEMPLATE_DELETE",
  PASSWORD_CHANGE = "PASSWORD_CHANGE",
  REVOLVING_CONTRACT = "REVOLVING_CONTRACT",
  TRANSACTION = "TRANSACTION",
  PAY_IN_THREE_REFINANCING = "PAY_IN_THREE_REFINANCING",
}
export enum AuthorizationResponseStateEnum {
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  EXPIRED = "EXPIRED",
  GRANTED = "GRANTED",
  WAITING = "WAITING",
}
export enum AuthorizationResponseTypeEnum {
  MOBILE_DEVICE = "MOBILE_DEVICE",
  OTP = "OTP",
  OTP_PASSWORD = "OTP_PASSWORD",
}
export enum AuthorizationRequestStateEnum {
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  GRANTED = "GRANTED",
}
export enum AssetCategoryTypeEnum {
  REAL_ESTATE = "REAL_ESTATE",
  MOVABLE_PROPERTY = "MOVABLE_PROPERTY",
  CASH = "CASH",
  INVESTMENTS = "INVESTMENTS",
  OTHER_ASSETS = "OTHER_ASSETS",
}
export enum AssetCategoryApproximateValueEnum {
  UP_TO_1_M = "UP_TO_1M",
  FROM_1_M_TO_5_M = "FROM_1M_TO_5M",
  FROM_5_M_TO_10_M = "FROM_5M_TO_10M",
  FROM_10_M_TO_20_M = "FROM_10M_TO_20M",
  FROM_20_M_TO_40_M = "FROM_20M_TO_40M",
  FROM_40_M_TO_100_M = "FROM_40M_TO_100M",
  OVER_100_M = "OVER_100M",
}
export enum AssetCategoryFinanceSourcesEnum {
  SAVINGS = "SAVINGS",
  GIFT = "GIFT",
  INHERITANCE = "INHERITANCE",
  LOAN_MORTGAGE = "LOAN_MORTGAGE",
  SALE_OF_ASSETS = "SALE_OF_ASSETS",
  DIVIDENDS = "DIVIDENDS",
  OTHER = "OTHER",
}
export enum IdentificationTypeEnum {
  BANK_ID = "BANK_ID",
}
export enum BankBusinessCardBICEnum {
  AGBACZPP = "AGBACZPP",
  AIRACZPP = "AIRACZPP",
  CEKOCZPP = "CEKOCZPP",
  FIOBCZPP = "FIOBCZPP",
  GIBACZPX = "GIBACZPX",
  KOMBCZPP = "KOMBCZPP",
  RZBCCZPP = "RZBCCZPP",
  CTASCZ_22 = "CTASCZ22",
  BACXCZPP = "BACXCZPP",
  BREXCZPP = "BREXCZPP",
  PTBNCZPP = "PTBNCZPP",
}
export enum GenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
}
export enum AddressTypeEnum {
  BILLING = "BILLING",
  CARD_DELIVERY = "CARD_DELIVERY",
  CONTACT = "CONTACT",
  DELIVERY = "DELIVERY",
  PERMANENT = "PERMANENT",
  TEMPORARY = "TEMPORARY",
}
export enum IdentityDocumentTypeEnum {
  ID_CARD = "ID_CARD",
  PASSPORT = "PASSPORT",
}
export enum KYCAuthorizationOriginSourceEnum {
  SETTINGS = "SETTINGS",
  REVOLVING_LIMIT_AMENDMENT = "REVOLVING_LIMIT_AMENDMENT",
  INSTALLMENTS = "INSTALLMENTS",
}
export enum KYCAuthorizationProductSourceTypeEnum {
  REVOLVING_APPLICATION_LIMIT_AMENDMENT = "REVOLVING_APPLICATION_LIMIT_AMENDMENT",
  INSTALLMENTS = "INSTALLMENTS",
}
export enum KYCAuthorizationViewSlugEnum {
  IDENTIFICATION_SELECTION = "IDENTIFICATION_SELECTION",
  BANK_ID_VERIFICATION_DECLINED = "BANK_ID_VERIFICATION_DECLINED",
  KYC_DATA_CUSTOMER_CONFIRMATION = "KYC_DATA_CUSTOMER_CONFIRMATION",
  COMPLETED = "COMPLETED",
}
export enum KYCValidationDeniedReasonEnum {
  MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA",
  SUSPICIOUS_CUSTOMER = "SUSPICIOUS_CUSTOMER",
  DOCUMENT_EXPIRED = "DOCUMENT_EXPIRED",
  UNSUPPORTED_NATIONALITY = "UNSUPPORTED_NATIONALITY",
  INVALID_PERSONAL_ID = "INVALID_PERSONAL_ID",
  UNSUPPORTED_AGE = "UNSUPPORTED_AGE",
  INVALID_DOCUMENT = "INVALID_DOCUMENT",
  SUSPICIOUS_PERSONAL_ID = "SUSPICIOUS_PERSONAL_ID",
  MODIFIED_PERSONAL_ID = "MODIFIED_PERSONAL_ID",
}
export enum KYCConfirmationStateEnum {
  CONFIRMED = "CONFIRMED",
  DECLINED = "DECLINED",
}
export enum DeferredPaymentMiniRevolvingPreferenceTypeEnum {
  DUE_DATE = "DUE_DATE",
  REVOLVING_LIMIT = "REVOLVING_LIMIT",
  DISCOUNT = "DISCOUNT",
  WARRANTY = "WARRANTY",
  INSURANCE = "INSURANCE",
  CASHBACK = "CASHBACK",
}
export enum CustomerCountry {
  SK = "SK",
  CZ = "CZ",
}
export enum ConsentsSlugEnum {
  MARKETING = "MARKETING",
  MARKETING_EXTENDED = "MARKETING_EXTENDED",
  REGISTRATION = "REGISTRATION",
}
export enum RegistrationStatusEnum {
  REGISTRATION_FINISHED = "REGISTRATION_FINISHED",
  REGISTRATION_FINISH_REQUIRED = "REGISTRATION_FINISH_REQUIRED",
}
export enum PromocodeTypeEnum {
  OTHER = "OTHER",
  REFEREE = "REFEREE",
  REFERRER = "REFERRER",
}
export enum MobilePlatformEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
}
export enum ScopeOfBusinessEnum {
  ACCOUNTING = "ACCOUNTING",
  BOUND = "BOUND",
  CRAFTING = "CRAFTING",
  FARMING = "FARMING",
  FINANCE = "FINANCE",
  INDEPENDENT = "INDEPENDENT",
  MEDICINE = "MEDICINE",
  MILITARY = "MILITARY",
  OTHERS = "OTHERS",
  PROFESSIONS = "PROFESSIONS",
  REAL_ESTATE = "REAL_ESTATE",
  RESTAURANT = "RESTAURANT",
  RETAIL = "RETAIL",
  TRANSPORT = "TRANSPORT",
}
export enum InstallmentStateEnum {
  AFTER_DUE_DATE = "AFTER_DUE_DATE",
  BEFORE_DUE_DATE = "BEFORE_DUE_DATE",
  PAID = "PAID",
  ZERO_CLAIM = "ZERO_CLAIM",
}
export enum InstallmentContractStateEnum {
  ACCELERATED = "ACCELERATED",
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  PAID = "PAID",
  PROCESSING = "PROCESSING",
  REJECTED = "REJECTED",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  WITHDRAWN = "WITHDRAWN",
}
export enum InstallmentsApplicationSlugEnum {
  INITIAL = "INITIAL",
  CUSTOMER_INFORMATION = "CUSTOMER_INFORMATION",
  KYC_REQUIRED = "KYC_REQUIRED",
  SCORING_LOADING = "SCORING_LOADING",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
  BUDGET_BAKERS_REDIRECT = "BUDGET_BAKERS_REDIRECT",
  BUDGET_BAKERS_LOADING = "BUDGET_BAKERS_LOADING",
  BUDGET_BAKERS_SELECT_BANK_ACCOUNT = "BUDGET_BAKERS_SELECT_BANK_ACCOUNT",
  BUDGET_BAKERS_COMPLETE = "BUDGET_BAKERS_COMPLETE",
  BUDGET_BAKERS_ERROR = "BUDGET_BAKERS_ERROR",
  INCOME_STATEMENT_CONFIRMATION = "INCOME_STATEMENT_CONFIRMATION",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  DECLINED_GENERAL = "DECLINED_GENERAL",
  DECLINED_SCORING_REGISTERS = "DECLINED_SCORING_REGISTERS",
  PRECONTRACTUAL_INFORMATION_CONFIRMATION = "PRECONTRACTUAL_INFORMATION_CONFIRMATION",
  AGREEMENT_SMS_CONFIRMATION = "AGREEMENT_SMS_CONFIRMATION",
  FIRST_PAYMENT = "FIRST_PAYMENT",
  RECALCULATION = "RECALCULATION",
}
export enum TypeOfHousingEnum {
  MUNICIPAL_HOUSING = "MUNICIPAL_HOUSING",
  OTHER = "OTHER",
  OWN = "OWN",
  PARENTS = "PARENTS",
  RENT = "RENT",
}
export enum HouseholdMembersCountEnum {
  ONE = "ONE",
  TWO = "TWO",
  THREE = "THREE",
  FOUR = "FOUR",
  FIVE = "FIVE",
  SIX = "SIX",
  SEVEN_AND_MORE = "SEVEN_AND_MORE",
}
export enum DependantsCountEnum {
  ZERO = "ZERO",
  ONE = "ONE",
  TWO = "TWO",
  THREE = "THREE",
  FOUR = "FOUR",
  FIVE = "FIVE",
  SIX_AND_MORE = "SIX_AND_MORE",
}
export enum SourceOfIncomeEnum {
  EMPLOYMENT = "EMPLOYMENT",
  BUSINESS_OWNER = "BUSINESS_OWNER",
  MATERNITY_LEAVE = "MATERNITY_LEAVE",
  OTHER = "OTHER",
  RETIREMENT = "RETIREMENT",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  SHORT_TERM_CONTRACT = "SHORT_TERM_CONTRACT",
  PART_TIME_EMPLOYMENT = "PART_TIME_EMPLOYMENT",
  PHD_STIPEND = "PHD_STIPEND",
  DISABILITY_PENSION = "DISABILITY_PENSION",
  WIDOW_PENSION = "WIDOW_PENSION",
  ANNUITY = "ANNUITY",
}
export enum BudgetBakersStateEnum {
  INIT_AUTHORIZATION = "INIT_AUTHORIZATION",
  AUTHORIZED = "AUTHORIZED",
  PROCESSING_BANK_ACCOUNTS_DOWNLOAD = "PROCESSING_BANK_ACCOUNTS_DOWNLOAD",
  BANK_ACCOUNTS_DOWNLOADED = "BANK_ACCOUNTS_DOWNLOADED",
  SELECT_BANK_ACCOUNT = "SELECT_BANK_ACCOUNT",
  PROCESSING_TRANSACTIONS_DOWNLOAD = "PROCESSING_TRANSACTIONS_DOWNLOAD",
  TRANSACTIONS_DOWNLOADED = "TRANSACTIONS_DOWNLOADED",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}
export enum BudgetBakersRequestStateEnum {
  COMPLETED = "COMPLETED",
}
export enum ProofOfIncomeMethodEnum {
  BANK_STATEMENT = "BANK_STATEMENT",
  BUDGET_BAKERS = "BUDGET_BAKERS",
}
export enum applicationStateEnum {
  CANCELLED = "CANCELLED",
}
export enum InvestmentsAccountStateEnum {
  REGISTRATION_IN_PROGRESS = "REGISTRATION_IN_PROGRESS",
  DELETED = "DELETED",
  WAITING_FOR_ACTIVATION = "WAITING_FOR_ACTIVATION",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export enum InvestmentTransactionTypeEnum {
  INVESTMENT_ONEOFF = "INVESTMENT_ONEOFF",
  INVESTMENT_REGULAR = "INVESTMENT_REGULAR",
  INVESTMENT_MALLPAY = "INVESTMENT_MALLPAY",
  WITHDRAWAL = "WITHDRAWAL",
}
export enum RevolvingTransactionTypeEnum {
  ATM_WITHDRAWAL_FEE = "ATM_WITHDRAWAL_FEE",
  ATM_WITHDRAWAL_FEE_DISCOUNT = "ATM_WITHDRAWAL_FEE_DISCOUNT",
  BILLING_OVERPAYMENT_TRANSFER = "BILLING_OVERPAYMENT_TRANSFER",
  BILLING_TRANSFER_PAYMENT_BONUS = "BILLING_TRANSFER_PAYMENT_BONUS",
  CARD_ATM_WITHDRAWAL = "CARD_ATM_WITHDRAWAL",
  CARD_ATM_WITHDRAWAL_FEE = "CARD_ATM_WITHDRAWAL_FEE",
  CARD_MONEYBACK_MASTERCARD_SPECIALS = "CARD_MONEYBACK_MASTERCARD_SPECIALS",
  CARD_ONLINE = "CARD_ONLINE",
  CARD_OTHER = "CARD_OTHER",
  CARD_REFUND_COMPLAINT = "CARD_REFUND_COMPLAINT",
  CARD_REFUND_MERCHANT = "CARD_REFUND_MERCHANT",
  CARD_REVERSAL = "CARD_REVERSAL",
  CARD_TRANSACTION = "CARD_TRANSACTION",
  CUSTOMER = "CUSTOMER",
  DEFERRED_BILLING_PAYMENT_FEE = "DEFERRED_BILLING_PAYMENT_FEE",
  DEFERRED_BILLING_PAYMENT_FROM_PREVIOUS_MONTH = "DEFERRED_BILLING_PAYMENT_FROM_PREVIOUS_MONTH",
  DEFERRED_BILLING_PAYMENT_TO_NEXT_MONTH = "DEFERRED_BILLING_PAYMENT_TO_NEXT_MONTH",
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  DEFERRED_PAYMENT_FREE_DELIVERY = "DEFERRED_PAYMENT_FREE_DELIVERY",
  DEFERRED_PAYMENT_OTHER = "DEFERRED_PAYMENT_OTHER",
  DEFERRED_PAYMENT_PROMOCODE = "DEFERRED_PAYMENT_PROMOCODE",
  DEFERRED_PAYMENT_RETURN = "DEFERRED_PAYMENT_RETURN",
  FEE = "FEE",
  FEE_DISCOUNT = "FEE_DISCOUNT",
  MICROINVESTMENT = "MICROINVESTMENT",
  MONEYBACK = "MONEYBACK",
  OTHER = "OTHER",
  PAYMENT_ORDER = "PAYMENT_ORDER",
  PAYMENT_ORDER_FEE = "PAYMENT_ORDER_FEE",
  PAYMENT_ORDER_FEE_DISCOUNT = "PAYMENT_ORDER_FEE_DISCOUNT",
  RETURNED_PAYMENT_ORDER = "RETURNED_PAYMENT_ORDER",
  REVOLVING_CREDIT_INSTALLMENT_SETTLEMENT = "REVOLVING_CREDIT_INSTALLMENT_SETTLEMENT",
  REVOLVING_LOAN_BILLING_REWARD = "REVOLVING_LOAN_BILLING_REWARD",
  REVOLVING_LOAN_PROMOCODE = "REVOLVING_LOAN_PROMOCODE",
  SANCTION = "SANCTION",
  PAY_IN_THREE_REFINANCING = "PAY_IN_THREE_REFINANCING",
}
export enum WalletEnum {
  APPLE_PAY = "APPLE_PAY",
  GARMIN_PAY = "GARMIN_PAY",
  GOOGLE_PAY = "GOOGLE_PAY",
  MI_PAY = "MI_PAY",
}
export enum OrderStateEnum {
  CANCELLED = "CANCELLED",
  DELIVERED = "DELIVERED",
  PROCESSING = "PROCESSING",
  RETURNED = "RETURNED",
  SENT = "SENT",
}
export enum PaymentOrderStateEnum {
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  REJECTED = "REJECTED",
}
export enum DocumentTypeEnum {
  BANK_STATEMENT = "BANK_STATEMENT",
  CONTRACT = "CONTRACT",
  CREDIT_NOTE = "CREDIT_NOTE",
  DRIVING_LICENSE_BACK = "DRIVING_LICENSE_BACK",
  DRIVING_LICENSE_FRONT = "DRIVING_LICENSE_FRONT",
  ID_CARD_BACK = "ID_CARD_BACK",
  ID_CARD_FRONT = "ID_CARD_FRONT",
  ID_CARD_SELFIE = "ID_CARD_SELFIE",
  INVOICE = "INVOICE",
  IPID = "IPID",
  OTHER = "OTHER",
  PASSPORT_BACK = "PASSPORT_BACK",
  PASSPORT_FRONT = "PASSPORT_FRONT",
  PASSPORT_SELFIE = "PASSPORT_SELFIE",
  PRECONTRACTUAL_INFORMATION = "PRECONTRACTUAL_INFORMATION",
  PRESUIT_DEMAND = "PRESUIT_DEMAND",
  PRICE_LIST = "PRICE_LIST",
  PROFORMA_INVOICE = "PROFORMA_INVOICE",
  RESIDENCE_PERMIT_FRONT = "RESIDENCE_PERMIT_FRONT",
  RESIDENCE_PERMIT_BACK = "RESIDENCE_PERMIT_BACK",
  REVOLVING_LOAN_FEE = "REVOLVING_LOAN_FEE",
  SANCTION = "SANCTION",
  TRANSACTIONS = "TRANSACTIONS",
  INSTALLMENTS_CONTRACT = "INSTALLMENTS_CONTRACT",
  INSTALLMENTS_PRECONTRACTUAL_INFORMATION = "INSTALLMENTS_PRECONTRACTUAL_INFORMATION",
  INSTALLMENTS_EXTRAORDINARY_PAYMENT = "INSTALLMENTS_EXTRAORDINARY_PAYMENT",
  INSTALLMENTS_PAID_OFF_CONFIRMATION = "INSTALLMENTS_PAID_OFF_CONFIRMATION",
  WITHDRAWAL_CONTRACT = "WITHDRAWAL_CONTRACT",
  APPENDIX_INCREASE_OR_DECREASE_LIMIT = "APPENDIX_INCREASE_OR_DECREASE_LIMIT",
  CONFIRMATION_DEPT_FREE = "CONFIRMATION_DEPT_FREE",
  CONFIRMATION_LOAN_AMOUNT = "CONFIRMATION_LOAN_AMOUNT",
  CONFIRMATION_TRANSACTION = "CONFIRMATION_TRANSACTION",
  CONFIRMATION_INSTALLMENT_PLAN = "CONFIRMATION_INSTALLMENT_PLAN",
  CONFIRMATION_CARD_MANAGEMENT = "CONFIRMATION_CARD_MANAGEMENT",
  REVOLVING_ANNUAL_FEE = "REVOLVING_ANNUAL_FEE",
  REVOVLING_APPLICATION_LIMIT_AMENDMENT_CONTRACT = "REVOVLING_APPLICATION_LIMIT_AMENDMENT_CONTRACT",
  REVOVLING_APPLICATION_LIMIT_AMENDMENT_PRECONTRACTUAL_INFORMATION = "REVOVLING_APPLICATION_LIMIT_AMENDMENT_PRECONTRACTUAL_INFORMATION",
  DEBT_REPAYMENT_PLAN_CONTRACT = "DEBT_REPAYMENT_PLAN_CONTRACT",
  DEBT_REPAYMENT_PLAN_PRECONTRACTUAL_INFORMATION = "DEBT_REPAYMENT_PLAN_PRECONTRACTUAL_INFORMATION",
  DEBT_REPAYMENT_PLAN_EXTRAORDINARY_PAYMENT = "DEBT_REPAYMENT_PLAN_EXTRAORDINARY_PAYMENT",
  DEBT_REPAYMENT_PLAN_PAID_OFF_CONFIRMATION = "DEBT_REPAYMENT_PLAN_PAID_OFF_CONFIRMATION",
  DEBT_REPAYMENT_PLAN_CONTRACT_ADDENDUM = "DEBT_REPAYMENT_PLAN_CONTRACT_ADDENDUM",
}
export enum InsuranceEventTypeEnum {
  DAMAGED = "DAMAGED",
  EXTENDED_WARRANTY = "EXTENDED_WARRANTY",
  STOLEN = "STOLEN",
}
export enum AvailableAmountStateEnum {
  AVAILABLE = "AVAILABLE",
  EXHAUSTED = "EXHAUSTED",
  BLOCKED = "BLOCKED",
  BLOCKED_MANUAL_REVIEW = "BLOCKED_MANUAL_REVIEW",
}
export enum CustomerBlockingReasonsEnum {
  BILLING_OVERDUE = "BILLING_OVERDUE",
  DEFERRED_PAYMENT_OVERDUE = "DEFERRED_PAYMENT_OVERDUE",
  PAY_IN_THREE_INSTALLMENT_OVERDUE = "PAY_IN_THREE_INSTALLMENT_OVERDUE",
}
export enum AvailablePayInThreeAmountStateEnum {
  AVAILABLE = "AVAILABLE",
  EXHAUSTED = "EXHAUSTED",
  BLOCKED = "BLOCKED",
  BLOCKED_MANUAL_REVIEW = "BLOCKED_MANUAL_REVIEW",
}
export enum RevolvingLoanApplicationStateEnum {
  CANCELLED = "CANCELLED",
  ERROR = "ERROR",
  FINISHED = "FINISHED",
  PROCESSING = "PROCESSING",
}
export enum RevolvingLoanStateEnum {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  PROCESSING = "PROCESSING",
  SIGNED = "SIGNED",
  TERMINATED = "TERMINATED",
}
export enum AccountTypeEnum {
  TRY_IT = "TRY_IT",
  PLUS = "PLUS",
}
export enum RevolvingLoanOldContractTypeEnum {
  START = "START",
  PLUS = "PLUS",
  COMPLETE = "COMPLETE",
}
export enum LimitAmendmentEntryStateEnum {
  AVAILABLE = "AVAILABLE",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  PROCESSING = "PROCESSING",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
}
export enum ApplicationStateEnum {
  CANCELLED = "CANCELLED",
  PROCESSING = "PROCESSING",
  READY = "READY",
  REJECTED = "REJECTED",
}
export enum ApplicationStateReasonEnum {
  CANCELLED_NOT_PAID = "CANCELLED_NOT_PAID",
  CANCELLED_RETURNED = "CANCELLED_RETURNED",
  CANCELLED_TO_RETURN = "CANCELLED_TO_RETURN",
  PROCESSING_ADDITIONAL_DATA = "PROCESSING_ADDITIONAL_DATA",
  PROCESSING_ALT_OFFER = "PROCESSING_ALT_OFFER",
  PROCESSING_APPROVED = "PROCESSING_APPROVED",
  PROCESSING_NEW = "PROCESSING_NEW",
  PROCESSING_PREAPPROVED = "PROCESSING_PREAPPROVED",
  PROCESSING_REDIRECT_NEEDED = "PROCESSING_REDIRECT_NEEDED",
  PROCESSING_REVIEW = "PROCESSING_REVIEW",
  PROCESSING_SIGNED = "PROCESSING_SIGNED",
  PROCESSING_VALIDATION_IN_PROGRESS = "PROCESSING_VALIDATION_IN_PROGRESS",
  PROCESSING_VERIFICATION = "PROCESSING_VERIFICATION",
  PROCESSING_WAIT_CLIENT = "PROCESSING_WAIT_CLIENT",
  READY_DELIVERED = "READY_DELIVERED",
  READY_DELIVERING = "READY_DELIVERING",
  READY_PAID = "READY_PAID",
  READY_SHIPPED = "READY_SHIPPED",
  READY_TO_PAY = "READY_TO_PAY",
  READY_TO_SHIP = "READY_TO_SHIP",
  REJECTED = "REJECTED",
}
export enum PaymentAvailabilityEnum {
  AVAILABLE = "AVAILABLE",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}
export enum PaymentAvailabilityReasonEnum {
  ALREADY_PAID = "ALREADY_PAID",
  BLOCKED = "BLOCKED",
  IN_REVOLVING_PAYMENT_PROCESS = "IN_REVOLVING_PAYMENT_PROCESS",
  BILLING_NOT_CLOSED = "BILLING_NOT_CLOSED",
  FULL_PAY_IN_THREE_REFINANCING_AVAILABLE = "FULL_PAY_IN_THREE_REFINANCING_AVAILABLE",
}
export enum PaymentAvailabilityMethodsEnum {
  CARD = "CARD",
  TRANSFER = "TRANSFER",
  REVOLVING = "REVOLVING",
}
export enum EshopBrokerSlugEnum {
  COMGATE = "COMGATE",
  CSOB_MIPS = "CSOB_MIPS",
}
export enum CarrierIdEnums {
  CZ_POST_HAND = "CZ_POST_HAND",
  CZ_POST_OFFICE = "CZ_POST_OFFICE",
  CZ_POST_OTHER = "CZ_POST_OTHER",
  PPL = "PPL",
  DPD = "DPD",
  GEIS = "GEIS",
  IN_TIME = "IN_TIME",
  TOP_TRANS = "TOP_TRANS",
  GEBRUDER_WEISS = "GEBRUDER_WEISS",
  LOCAL_COURIER = "LOCAL_COURIER",
  TNT = "TNT",
  GLS = "GLS",
  HDS_COMFORT = "HDS_COMFORT",
  HDS_STANDARD = "HDS_STANDARD",
}
export enum RewardsTypeEnum {
  FREE_DELIVERY = "FREE_DELIVERY",
}
export enum OrderItemTypeEnum {
  DIGITAL = "DIGITAL",
  DISCOUNT = "DISCOUNT",
  FEE = "FEE",
  GIFT_CARD = "GIFT_CARD",
  INSURANCE = "INSURANCE",
  PHYSICAL = "PHYSICAL",
  SALES_TAX = "SALES_TAX",
  SHIPPING_FEE = "SHIPPING_FEE",
  STORE_CREDIT = "STORE_CREDIT",
}
export enum OrderTypeEnum {
  GOODS = "GOODS",
  GOODS_BROKER = "GOODS_BROKER",
}
export enum ApplicationFinancingTypeEnum {
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  PAY_IN_THREE = "PAY_IN_THREE",
}
export enum OnlinePaymentTypeEnum {
  CARD = "CARD",
  OTHER = "OTHER",
}
export enum OnlinePaymentCardCampaignEnum {
  CSOB_CARD = "CSOB_CARD",
}
export enum ApplicationTransactionTypeEnum {
  CLAIM_DEFERRED_PAYMENT = "CLAIM_DEFERRED_PAYMENT",
  CLAIM_SANCTION = "CLAIM_SANCTION",
  CUSTOMER_CREDIT_NOTE_DEFERRED_PAYMENT = "CUSTOMER_CREDIT_NOTE_DEFERRED_PAYMENT",
  CUSTOMER_CREDIT_NOTE_REVOLVING = "CUSTOMER_CREDIT_NOTE_REVOLVING",
  CUSTOMER_CREDIT_NOTE_SANCTION = "CUSTOMER_CREDIT_NOTE_SANCTION",
  CUSTOMER_CREDIT_NOTE_ONLINE_PAYMENT_REVERSION = "CUSTOMER_CREDIT_NOTE_ONLINE_PAYMENT_REVERSION",
  CUSTOMER_DEFERRED_PAYMENT = "CUSTOMER_DEFERRED_PAYMENT",
  CUSTOMER_REVOLVING = "CUSTOMER_REVOLVING",
  CUSTOMER_SANCTION = "CUSTOMER_SANCTION",
  DISCOUNT_FREE_DELIVERY = "DISCOUNT_FREE_DELIVERY",
  DISCOUNT_MALLCOIN_FREE_DELIVERY = "DISCOUNT_MALLCOIN_FREE_DELIVERY",
  DISCOUNT_PROMOCODE = "DISCOUNT_PROMOCODE",
  REVOLVING_CUSTOMER_SANCTION = "REVOLVING_CUSTOMER_SANCTION",
  REVOLVING_DEBIT_REFINANCING = "REVOLVING_DEBIT_REFINANCING",
}
export enum AccountingSystemEnum {
  DOUBLE_ENTRY = "DOUBLE_ENTRY",
  PERCENT_FROM_INCOME = "PERCENT_FROM_INCOME",
  TAX_RECORD = "TAX_RECORD",
}
export enum KycIdentificationMethodEnum {
  BANK_ID = "BANK_ID",
  OFFICE = "OFFICE",
  SIMPLE_CUSTOMER_IDENTIFICATION = "SIMPLE_CUSTOMER_IDENTIFICATION",
}
export enum CardTypeEnum {
  PHYSICAL = "PHYSICAL",
  VIRTUAL = "VIRTUAL",
}
export enum BankIdValidationDeniedReasonEnum {
  CUSTOMER_DECLINED = "CUSTOMER_DECLINED",
  DOCUMENT_ID_EXPIRED = "DOCUMENT_ID_EXPIRED",
  INVALID_PERSONAL_ID = "INVALID_PERSONAL_ID",
  INVALID_DOCUMENT_ID = "INVALID_DOCUMENT_ID",
  MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA",
  SUSPICIOUS_PERSONAL_ID = "SUSPICIOUS_PERSONAL_ID",
  UNSUPPORTED_AGE = "UNSUPPORTED_AGE",
  UNSUPPORTED_NATIONALITY = "UNSUPPORTED_NATIONALITY",
  SUSPICIOUS_CUSTOMER = "SUSPICIOUS_CUSTOMER",
}
export enum BudgetBakersValidationResultEnum {
  APPROVED = "APPROVED",
  BO_RECOMMENDED_APPROVE = "BO_RECOMMENDED_APPROVE",
  BO_WITHOUT_RECOMMENDATION = "BO_WITHOUT_RECOMMENDATION",
  BO_RECOMMENDED_DENY = "BO_RECOMMENDED_DENY",
  DENIED = "DENIED",
  DENIED_WITH_RETRY_INCOME_MISMATCH = "DENIED_WITH_RETRY_INCOME_MISMATCH",
  DENIED_WITH_RETRY_NAME_MISMATCH = "DENIED_WITH_RETRY_NAME_MISMATCH",
}
export enum AccountUpgradeApplicationSlugEnum {
  SINGLE_KYC_DATA_CUSTOMER_CONFIRMATION = "SINGLE_KYC_DATA_CUSTOMER_CONFIRMATION",
  SINGLE_KYC_DATA_INVALIDATED = "SINGLE_KYC_DATA_INVALIDATED",
  BANK_ID_DATA_CUSTOMER_CONFIRMATION = "BANK_ID_DATA_CUSTOMER_CONFIRMATION",
  BANK_ID_VERIFICATION_FAILED = "BANK_ID_VERIFICATION_FAILED",
  BANK_ID_VERIFICATION_FAILED_NOT_PERSONAL = "BANK_ID_VERIFICATION_FAILED_NOT_PERSONAL",
  BUDGET_BAKERS_COMPLETE = "BUDGET_BAKERS_COMPLETE",
  BUDGET_BAKERS_ERROR = "BUDGET_BAKERS_ERROR",
  BUDGET_BAKERS_INCOME_MISMATCH = "BUDGET_BAKERS_INCOME_MISMATCH",
  BUDGET_BAKERS_LOADING = "BUDGET_BAKERS_LOADING",
  BUDGET_BAKERS_NAME_MISMATCH = "BUDGET_BAKERS_NAME_MISMATCH",
  BUDGET_BAKERS_REDIRECT = "BUDGET_BAKERS_REDIRECT",
  BUDGET_BAKERS_SELECT_BANK_ACCOUNT = "BUDGET_BAKERS_SELECT_BANK_ACCOUNT",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  CONFIRMATION_AGREEMENT_SMS = "CONFIRMATION_AGREEMENT_SMS",
  CUSTOMER_IDENTIFICATION = "CUSTOMER_IDENTIFICATION",
  CONFIRMATION_INCOME_STATEMENT = "CONFIRMATION_INCOME_STATEMENT",
  CUSTOMER_INFORMATION_INCOME_AND_EXPENSES = "CUSTOMER_INFORMATION_INCOME_AND_EXPENSES",
  CUSTOMER_INFORMATION_HOUSING_AND_DEPENDANTS = "CUSTOMER_INFORMATION_HOUSING_AND_DEPENDANTS",
  CONFIRMATION_LIMIT = "CONFIRMATION_LIMIT",
  DECLINED_GENERAL = "DECLINED_GENERAL",
  DECLINED_SCORING_REGISTERS = "DECLINED_SCORING_REGISTERS",
  SIMPLE_CUSTOMER_IDENTIFICATION_DATA_COLLECTED = "SIMPLE_CUSTOMER_IDENTIFICATION_DATA_COLLECTED",
  SIMPLE_CUSTOMER_IDENTIFICATION_DATA_COLLECTING = "SIMPLE_CUSTOMER_IDENTIFICATION_DATA_COLLECTING",
  SIMPLE_CUSTOMER_IDENTIFICATION_SCAN_INITIALIZED = "SIMPLE_CUSTOMER_IDENTIFICATION_SCAN_INITIALIZED",
  SIMPLE_CUSTOMER_IDENTIFICATION_SCAN_IN_PROGRESS = "SIMPLE_CUSTOMER_IDENTIFICATION_SCAN_IN_PROGRESS",
  SCORING_LOADING = "SCORING_LOADING",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
  UNKNOWN_INVALID = "UNKNOWN_INVALID",
}
export enum BillingDefermentStateEnum {
  AVAILABLE = "AVAILABLE",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  SUCCESS = "SUCCESS",
  WAITING_FOR_PAYMENT = "WAITING_FOR_PAYMENT",
}
export enum BillingDefermentUnavailableStateReasonEnum {
  AMOUNT_TO_PAY_TOO_LOW = "AMOUNT_TO_PAY_TOO_LOW",
  BILLING_NOT_CLOSED = "BILLING_NOT_CLOSED",
  BILLING_PAYMENT_OVERDUE = "BILLING_PAYMENT_OVERDUE",
  LOAN_ACCELERATION = "LOAN_ACCELERATION",
}
export enum MarketingCampaignEnum {
  CHRISTMAS = "CHRISTMAS",
  FREE_DEFERMENT = "FREE_DEFERMENT",
}
export enum BillingDefermentRequestInput_appliedRewards {
  BILLING_DEFERMENT_FOR_COINS = "BILLING_DEFERMENT_FOR_COINS",
}
export enum MoneybackApplicationOptionsEnum {
  OLDEST_DEFERRED_PAYMENT = "OLDEST_DEFERRED_PAYMENT",
  FOLLOWING_CAMS_TRANSACTION = "FOLLOWING_CAMS_TRANSACTION",
}
export enum ExportFormatEnum {
  CSV = "CSV",
  PDF = "PDF",
  XLSX = "XLSX",
}
export enum ExportedFileStateEnum {
  PROCESSING = "PROCESSING",
  READY = "READY",
}
export enum ComplaintForTransactionStatusEnum {
  ANY_COMPLAINT_EXISTS = "ANY_COMPLAINT_EXISTS",
  COMPLAINT_DOES_NOT_EXIST = "COMPLAINT_DOES_NOT_EXIST",
}
export enum RevolvingTransactionComplaintReasonEnum {
  PAYMENT_CHARGED_MULTIPLE_TIMES = "PAYMENT_CHARGED_MULTIPLE_TIMES",
  CLAIMING_GOODS_OR_SERVICES = "CLAIMING_GOODS_OR_SERVICES",
  PAYMENT_MADE_ILLEGALLY_BY_ANOTHER_PERSON = "PAYMENT_MADE_ILLEGALLY_BY_ANOTHER_PERSON",
  OTHER = "OTHER",
}
export enum ContractLimitAmendmentApplicationSlugEnum {
  LIMIT_SELECTION = "LIMIT_SELECTION",
  KYC_REQUIRED = "KYC_REQUIRED",
  COLLECTING_PERSONAL_DATA = "COLLECTING_PERSONAL_DATA",
  SCORING_LOADING = "SCORING_LOADING",
  LIMIT_CONFIRMATION = "LIMIT_CONFIRMATION",
  BUDGET_BAKERS_REDIRECT = "BUDGET_BAKERS_REDIRECT",
  BUDGET_BAKERS_LOADING = "BUDGET_BAKERS_LOADING",
  BUDGET_BAKERS_SELECT_BANK_ACCOUNT = "BUDGET_BAKERS_SELECT_BANK_ACCOUNT",
  BUDGET_BAKERS_COMPLETE = "BUDGET_BAKERS_COMPLETE",
  BUDGET_BAKERS_ERROR = "BUDGET_BAKERS_ERROR",
  INCOME_STATEMENT_CONFIRMATION = "INCOME_STATEMENT_CONFIRMATION",
  AGREEMENT_SMS_CONFIRMATION = "AGREEMENT_SMS_CONFIRMATION",
  DECLINED_GENERAL = "DECLINED_GENERAL",
  DECLINED_SCORING_REGISTERS = "DECLINED_SCORING_REGISTERS",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  FINAL_SCORING_LOADING = "FINAL_SCORING_LOADING",
}
export enum BudgetBakersLimitAmendmentValidationResultEnum {
  APPROVED = "APPROVED",
  BO_RECOMMENDED_APPROVE = "BO_RECOMMENDED_APPROVE",
  BO_WITHOUT_RECOMMENDATION = "BO_WITHOUT_RECOMMENDATION",
  BO_RECOMMENDED_DENY = "BO_RECOMMENDED_DENY",
  DENIED = "DENIED",
}
export enum DebtRepaymentPlanApplicationSlugEnum {
  AGREEMENT_SMS_CONFIRMATION = "AGREEMENT_SMS_CONFIRMATION",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
export enum EmailTypeEnum {
  PRIMARY_EMAIL = "PRIMARY_EMAIL",
  CONTACT_EMAIL = "CONTACT_EMAIL",
}
export enum PhoneTypeEnum {
  CONTACT = "CONTACT",
  MOBILE = "MOBILE",
  PHONE = "PHONE",
  PRIMARY = "PRIMARY",
}
export enum SurveyTypeEnum {
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  PAY_IN_THREE = "PAY_IN_THREE",
  PLUS = "PLUS",
}
export enum PersonalDataRequestStatusEnum {
  ACCEPTED = "ACCEPTED",
  UNCONFIRMED = "UNCONFIRMED",
}
export enum PaymentCardStateEnum {
  ACTIVATED = "ACTIVATED",
  ASSIGNED = "ASSIGNED",
  BLOCKED_PERMANENTLY = "BLOCKED_PERMANENTLY",
  BLOCKED_TEMPORARILY = "BLOCKED_TEMPORARILY",
  OTHER = "OTHER",
  EXPIRED = "EXPIRED",
}
export enum PaymentCardStateReasonEnum {
  FRAUD = "FRAUD",
  LOST = "LOST",
  STOLEN = "STOLEN",
  WRONG_PIN = "WRONG_PIN",
  SUSPECTED_FRAUD_CSOB = "SUSPECTED_FRAUD_CSOB",
}
export enum PaymentCardTemporaryBlockStateEnum {
  BLOCKED_TEMPORARILY = "BLOCKED_TEMPORARILY",
}
export enum PaymentCardPermanentBlockStateEnum {
  BLOCKED_PERMANENTLY = "BLOCKED_PERMANENTLY",
}
export enum PaymentCardPermanentBlockReasonEnum {
  FRAUD = "FRAUD",
  LOST = "LOST",
  STOLEN = "STOLEN",
  CHANGE_CONTRACT_TYPE = "CHANGE_CONTRACT_TYPE",
  NEW_CARD_ISSUING_EXPIRATION_REASON = "NEW_CARD_ISSUING_EXPIRATION_REASON",
}
export enum PaymentOrderTemplateBase_1_frequency {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  HALF_YEARLY = "HALF_YEARLY",
  YEARLY = "YEARLY",
}
export enum PaymentOrderTemplateResponse_1_state {
  WAITING_FOR_AUTHORIZATION = "WAITING_FOR_AUTHORIZATION",
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
}
export enum PaymentOrderTemplateBaseInput_1Input_frequency {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  HALF_YEARLY = "HALF_YEARLY",
  YEARLY = "YEARLY",
}
export enum DirectDebitStatusEnum {
  ACTIVE = "ACTIVE",
  CANCELLATION_PENDING = "CANCELLATION_PENDING",
  ACTIVATION_PENDING = "ACTIVATION_PENDING",
  CANCELLED = "CANCELLED",
}
export enum PaymentDayEnum {
  FIRST_DAY_OF_MONTH = "FIRST_DAY_OF_MONTH",
  LAST_DAY_BEFORE_DUE_DATE = "LAST_DAY_BEFORE_DUE_DATE",
}
export enum DirectDebitStatusDeactivedEnum {
  CANCELLATION_PENDING = "CANCELLATION_PENDING",
  CANCELLED = "CANCELLED",
}
export enum PaymentMethodEnum {
  CARD = "CARD",
  EKONTO = "EKONTO",
  MOJE_PLATBA = "MOJE_PLATBA",
  PLATBA_24 = "PLATBA24",
  TRANSFER = "TRANSFER",
  REVOLVING = "REVOLVING",
}
export enum OnlinePaymentStateEnum {
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}
export enum BatchUploadDocumentsTypeEnum {
  ID_CARD_UPLOAD = "ID_CARD_UPLOAD",
  OTHER_UPLOAD = "OTHER_UPLOAD",
  BANK_STATEMENT_UPLOAD = "BANK_STATEMENT_UPLOAD",
  OTHER_CONFIRMATION_UPLOAD = "OTHER_CONFIRMATION_UPLOAD",
}
export enum TransactionDirectionEnum {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT",
}
export enum CoinTransactionReasonEnum {
  APP_DOWNLOAD_BONUS = "APP_DOWNLOAD_BONUS",
  BILLING_REWARD = "BILLING_REWARD",
  DELIVERY_DISCOUNT = "DELIVERY_DISCOUNT",
  EXPIRATION = "EXPIRATION",
  MONTHLY_BILLING_PAID = "MONTHLY_BILLING_PAID",
  DEFERRED_PAYMENT_PAID = "DEFERRED_PAYMENT_PAID",
  PAY_IN_THREE_PAID = "PAY_IN_THREE_PAID",
  MANUAL = "MANUAL",
  PAID_ITEM_RETURNED = "PAID_ITEM_RETURNED",
  VOUCHER_ACQUISITION = "VOUCHER_ACQUISITION",
  WHEEL_OF_FORTUNE = "WHEEL_OF_FORTUNE",
  BILLING_DEFERMENT_FOR_COINS = "BILLING_DEFERMENT_FOR_COINS",
  FEE_DISCOUNT = "FEE_DISCOUNT",
  PAYMENT_ORDER_FEE_DISCOUNT = "PAYMENT_ORDER_FEE_DISCOUNT",
  ATM_WITHDRAWAL_FEE_DISCOUNT = "ATM_WITHDRAWAL_FEE_DISCOUNT",
}
export enum BadgeTypeEnum {
  SKIP_PAY = "SKIP_PAY",
}
export enum Partner_1_paymentMethod {
  DEFERRED_PAYMENT = "DEFERRED_PAYMENT",
  PAY_IN_THREE = "PAY_IN_THREE",
  ALL = "ALL",
  NONE = "NONE",
}
export enum PromocodeOfferStateEnum {
  IN_OFFER = "IN_OFFER",
  NEVER_OFFERED = "NEVER_OFFERED",
  WAS_OFFERED = "WAS_OFFERED",
}
export enum PhoneSupportTypeEnum {
  REVOLVING_LOAN_CALL_ME = "REVOLVING_LOAN_CALL_ME",
  REVOLVING_LOAN_CANCELLATION_REQUEST = "REVOLVING_LOAN_CANCELLATION_REQUEST",
  REVOLVING_LOAN_INCREASE_LIMIT = "REVOLVING_LOAN_INCREASE_LIMIT",
}
export enum RevolvingLoanFeeSlugEnum {
  PAYMENT_ORDER_FEE = "PAYMENT_ORDER_FEE",
}
export enum SimpleCustomerIdentificationResponseStateEnum {
  INITIALIZED = "INITIALIZED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}
export enum SimpleCustomerIdentificationContinueOnDeviceEnum {
  MOBILE = "MOBILE",
  DESKTOP = "DESKTOP",
}
export enum SimpleCustomerIdentificationDocumentTypeEnum {
  ID_CARD_BACK = "ID_CARD_BACK",
  ID_CARD_FRONT = "ID_CARD_FRONT",
  ID_CARD_SELFIE = "ID_CARD_SELFIE",
  PASSPORT_FRONT = "PASSPORT_FRONT",
  PASSPORT_SELFIE = "PASSPORT_SELFIE",
  RESIDENCE_PERMIT_FRONT = "RESIDENCE_PERMIT_FRONT",
  RESIDENCE_PERMIT_BACK = "RESIDENCE_PERMIT_BACK",
}
export enum SimpleCustomerIdentificationRequestStateEnum {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}
export enum OutageAffectedSystemEnum {
  NEW_REVOLVING_LOAN_APPLICATION = "NEW_REVOLVING_LOAN_APPLICATION",
  REVOLVING_LOAN_APPLICATION_COMPLETION = "REVOLVING_LOAN_APPLICATION_COMPLETION",
  QR_PAYMENTS = "QR_PAYMENTS",
  GATE = "GATE",
  GATE_PAY_IN_THREE_TRY_IT = "GATE_PAY_IN_THREE_TRY_IT",
  GATE_PAY_IN_THREE_PLUS = "GATE_PAY_IN_THREE_PLUS",
  GATE_DEFERRED_PAYMENT_TRY_IT = "GATE_DEFERRED_PAYMENT_TRY_IT",
  GATE_DEFERRED_PAYMENT_PLUS = "GATE_DEFERRED_PAYMENT_PLUS",
  INSTALLMENTS_APPLICATION = "INSTALLMENTS_APPLICATION",
  REVOLVING_LOAN_APPLICATION_LIMIT_AMENDMENT = "REVOLVING_LOAN_APPLICATION_LIMIT_AMENDMENT",
}
export enum wheelOfFortune_slug {
  VERSION_1 = "VERSION_1",
  VERSION_2 = "VERSION_2",
}
export enum wheelOfFortuneCreate_slug {
  VERSION_1 = "VERSION_1",
  VERSION_2 = "VERSION_2",
}
export enum WheelOfFortuneRewardTypeEnum {
  ANOTHER_TRY = "ANOTHER_TRY",
  NOTHING = "NOTHING",
  PARTNER_REWARD = "PARTNER_REWARD",
  PAYMENT_PROMOCODE = "PAYMENT_PROMOCODE",
  PAYMENT_PROMOCODE_2 = "PAYMENT_PROMOCODE_2",
}
export enum FeatureStateEnum {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
export enum ComissionRateEnum {
  FIXED = "FIXED",
  FIXED_PER_ORDER = "FIXED_PER_ORDER",
  PERCENT = "PERCENT",
}
export enum LockingMethodEnum {
  FIXED_DURATION = "FIXED_DURATION",
  OPEN_ENDED = "OPEN_ENDED",
  FIXED_DATE = "FIXED_DATE",
  IMMEDIATE = "IMMEDIATE",
}
export enum CashbackOrderTypeEnum {
  ORDER = "ORDER",
  PROMOCODE = "PROMOCODE",
}
export enum CashbackOrderValidationStatusTypeEnum {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  DECLINED = "DECLINED",
  AUTOMATED = "AUTOMATED",
}